export default "/brand/_assets/images/banner.jpg";